import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WelcomeMessage = ({ onStartConversation }) => {
  const features = [
    {
      icon: 'Zap',
      title: 'Instant Responses',
      description: 'Get immediate answers to your questions about our services and capabilities.',
      question: 'Tell me about your instant response capabilities and services.'
    },
    {
      icon: 'Brain',
      title: 'Smart Assistance',
      description: 'AI-powered support that understands your project needs and requirements.',
      question: 'How can your AI help me with my project requirements?'
    },
    {
      icon: 'Users',
      title: 'Human Handoff',
      description: 'Seamless transition to our expert team when you need detailed consultation.',
      question: 'How do I connect with your expert team for consultation?'
    },
    {
      icon: 'Shield',
      title: 'Secure & Private',
      description: 'Your conversations are encrypted and handled with complete confidentiality.',
      question: 'Tell me about your security and privacy measures.'
    }
  ];

  const sampleQuestions = [
    "What's your pricing for a custom web application?",
    "How long does a typical mobile app project take?",
    "Can you help with e-commerce development?",
    "What technologies do you specialize in?",
    "Do you provide ongoing maintenance and support?"
  ];

  return (
    <div className="h-[536px] overflow-y-auto p-6 text-center">
      <div className="mb-6">
        <div className="w-16 h-16 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center mx-auto mb-4 shadow-brand-lg">
          <Icon name="Bot" size={28} color="black" />
        </div>
        <h2 className="text-xl font-bold text-foreground mb-2">Welcome to bytepairs AI Assistant</h2>
        <p className="text-text-secondary text-sm leading-relaxed">
          I'm here to help you learn about our digital solutions, get pricing information,
          and guide you through your project journey. Let's start a conversation!
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3 mb-6">
        {features.map((feature, index) => (
          <button
            key={index}
            onClick={() => onStartConversation(feature.question)}
            className="text-center p-3 rounded-lg bg-muted/50 hover:bg-primary/10 hover:border-primary/30 border border-transparent transition-all duration-300 cursor-pointer"
          >
            <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-2">
              <Icon name={feature.icon} size={16} className="text-primary" />
            </div>
            <h4 className="font-medium text-xs text-foreground mb-1">{feature.title}</h4>
            <p className="text-xs text-text-secondary leading-tight">{feature.description}</p>
          </button>
        ))}
      </div>

      <div className="mb-6">
        <h3 className="font-medium text-sm text-foreground mb-3">Popular Questions</h3>
        <div className="space-y-2">
          {sampleQuestions.slice(0, 3).map((question, index) => (
            <button
              key={index}
              onClick={() => onStartConversation(question)}
              className="w-full text-left p-3 rounded-lg border border-border hover:border-primary/30 hover:bg-primary/5 transition-all duration-300 text-xs text-text-secondary hover:text-foreground"
            >
              <div className="flex items-center space-x-2">
                <Icon name="MessageCircle" size={14} className="text-primary flex-shrink-0" />
                <span className="truncate">{question}</span>
              </div>
            </button>
          ))}
        </div>
      </div>

      <Button
        variant="default"
        onClick={() => onStartConversation("Hello! I'd like to learn more about bytepairs' services.")}
        className="w-full bg-gradient-to-r from-primary to-accent hover:from-primary/90 hover:to-accent/90 shadow-brand"
        iconName="MessageCircle"
        iconPosition="left"
      >
        Start Conversation
      </Button>
    </div>
  );
};

export default WelcomeMessage;